module.exports = __webpack_public_path__ + "1-21.png?9d0a098e39a3edfd6c274362ff28b1b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-21.png
// module id = 98
// module chunks = 0